<template>
  <div>
    <v-list>
      <ListItem
        :title="zone.name"
        :subtitle="$t('fields.name')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'ZoneDetails',
    components: { ListItem },
    props: {
      zone: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
    },
  };
</script>
